export default "__VITE_ASSET__bme2FMwS__"